// extracted by mini-css-extract-plugin
export var danger = "_3q-6";
export var lightPink = "_3q-a";
export var medium = "_3q-j";
export var nearSquare = "_3q-m";
export var neutralBlue = "_3q-8";
export var neutralYellow = "_3q-7";
export var noCapitalize = "_3q-1";
export var normal = "_3q-2";
export var pill = "_3q-0";
export var primary = "_3q-3";
export var primaryLight = "_3q-4";
export var shadow = "_3q-n";
export var small = "_3q-k";
export var solidBlack = "_3q-i";
export var solidGreen = "_3q-d";
export var solidLightBlue = "_3q-f";
export var solidNavy = "_3q-e";
export var solidOrange = "_3q-h";
export var solidPink = "_3q-g";
export var solidRed = "_3q-b";
export var solidWhite = "_3q-9";
export var solidYellow = "_3q-c";
export var success = "_3q-5";
export var xsmall = "_3q-l";